import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ShowQnsModal = ({ showQnsModal, setShowQnsModal, questions, handleCopyId, handleEditClick }) => {
  return (
    <Modal show={showQnsModal} onHide={() => setShowQnsModal(false)} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>All Questions</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }} className='custom-scrollBar'>
        <ul className="list-unstyled">
          {Object.values(questions).map((q) => (
            <li key={q.id} className="border rounded p-2 mb-2 d-flex justify-content-between align-items-start">
              <div>
                <strong>{q.id} - {q.response_key}</strong>
                <div>{q.question}</div>
              </div>
              <div className="d-flex gap-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleCopyId(q.id)}
                >
                  Copy ID
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => {
                    handleEditClick(q.id);
                    setShowQnsModal(false);
                  }}
                >
                  Edit
                </Button>
              </div>
            </li>
          ))}
        </ul>
      </Modal.Body>
    </Modal>
  );
};

export default ShowQnsModal;
 